import React from 'react';
import { browserHistory } from 'react-router';
import {
  ButtonToolbar,
  Button,
  DatePicker,
  DropdownButton,
  MenuItem,
} from 'react-bootstrap';
import moment from 'moment';
import { Link } from 'react-router';
import { SearchField } from 'react-bootstrap-table';
import BookingRequestBadge from './BookingRequestBadge';
import InfiniteScroll from 'react-infinite-scroller'
import { START_DATE, END_DATE, SingleDatePicker, ICON_BEFORE_POSITION } from 'react-dates';
import Griddle, { plugins, RowDefinition, ColumnDefinition } from 'griddle-react';
import DateRangePicker from 'react-daterange-picker';

const styleConfig = {
  icons: {
    TableHeadingCell: {
      sortDescendingIcon: '▼',
      sortAscendingIcon: '▲',
    },
  },
  classNames: {
    Row: 'row-class',
    Table: 'table-striped table',
    Filter: 'request-page-griddle-filter'
  },
  styles: {

  },
};

const statusOptions = [
  'All Requests', 'Active', 'Archived', 'Pinned'
];


class BookingRequestList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      viewMode:'list',
      selectedStatusOption: statusOptions[0],// default All Requests show
      startDate: moment().subtract(24, 'months').startOf('month'),
      endDate: moment().add(6, 'months').startOf('month'),
      calendarFocused: false,
      endCalendarFocused: false,
      isCalledFrom: 0,
      searchTerm:'',
      allBookingRequestList:[],
      isInitialLoad: true,
      totalRequests:0,
      isCalendarOpen: false,
      tourStatus:[],
    };

    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.changeView = this.changeView.bind(this);
    this.handleStatusSelect = this.handleStatusSelect.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.onEndDateChange = this.onEndDateChange.bind(this);
    this.onFocusChange = this.onFocusChange.bind(this);
    this.onEndDateFocusChange = this.onEndDateFocusChange.bind(this);
    this.handleShowCards = this.handleShowCards.bind(this);
    this.handleTogglePinUnpinIcon = this.handleTogglePinUnpinIcon.bind(this);
    this.handleArchive = this.handleArchive.bind(this);
    this.chageTourState = this.chageTourState.bind(this);
    this.handleSearchTerm = this.handleSearchTerm.bind(this);
    this.actionAfterFilterData = this.actionAfterFilterData.bind(this);
    this.showDetailView = this.showDetailView.bind(this);
    this.handleToggleCalendar = this.handleToggleCalendar.bind(this);
    this.onDateRangeSelect = this.onDateRangeSelect.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }
  componentWillMount(){
    document.addEventListener('mousedown', this.handleClick, false);
  }
  componentWillUnmount(){
    document.addEventListener('mousedown', this.handleClick, false);
  }
  handleClick = (e) => {
    if(this.node.contains(e.target) || e.target.id == "bookingRequestsDateRange"){
      return;
    }
    this.handleClickOutside();
  }
  handleClickOutside(){
    this.setState({
      isCalendarOpen: !this.state.isCalendarOpen
    })
  }
  handleOpenModal() {
    this.setState({ showModal: true });
  }

  showDetailView(e){
    const id = e.currentTarget.getAttribute('data-item');    
    browserHistory.push(`/booking/${id}`);
  }

  handleCloseModal() {
    this.setState({ showModal: false });
  }
  chageTourState(){
    let allBookingRequestList = this.state.allBookingRequestList;
    let tourStatus = this.state.tourStatus
    allBookingRequestList.map((v)=>{
      tourStatus.map((s)=>{
        if (v.tour.id==s.tour){
          v.tour.state="Archived"
        }
      })
    })
    this.setState({allBookingRequestList:allBookingRequestList})
  }

  loadFunc = (page) => {
    this.props.requestBookings(page - 1, this.state.searchTerm, this.state.selectedStatusOption, this.state.startDate.format('YYYY-MM-DD'), this.state.endDate.format('YYYY-MM-DD'), (response) => {
      if(typeof(response.results) != 'undefined'){
        // this.setState({ allBookingRequestList:  response.results});
        if(this.state.selectedStatusOption=="All Requests"){
          this.props.getTour((response)=>{
            this.setState({ tourStatus:response.results});
            this.chageTourState();
          });
        }
      }      
    }); 
  }
  
  onFocusChange({ focused }) {
    this.setState({ calendarFocused: focused });
  }

  onEndDateFocusChange({ focused }) {
    this.setState({ endCalendarFocused: focused });
  }

  onDateChange(startDate) {
    this.setState(({ startDate }));
    this.actionAfterFilterData(0, this.state.searchTerm, this.state.selectedStatusOption, startDate.format('YYYY-MM-DD'), this.state.endDate.format('YYYY-MM-DD'));
  }
  handleArchive(request,value){
    let id = request.id
    let payload = {"id":id,"state":value}
    this.props.editTour(id,payload,(response)=>{
      window.location.reload(true);
    });

  }

  //Function to set pin-unpin state of request
  handleTogglePinUnpinIcon(isPin, id){
    const payloadProposal = {
      id: id,
      is_pin: false
    };

    if(isPin === true){
      payloadProposal.is_pin = false;
    }else{
      payloadProposal.is_pin = true;
    }

    this.props.updatePinUnpin( id, payloadProposal, (response) => {
      this.actionAfterFilterData(0, this.state.searchTerm, this.state.selectedStatusOption, this.state.startDate.format('YYYY-MM-DD'), this.state.endDate.format('YYYY-MM-DD'));       
      handleShowCards();
    });
  }  
  
  handleShowCards(){
    let hotels = [];
    if(this.state.allBookingRequestList.length == 0 && this.props.requests.length > 0 && this.state.isInitialLoad == true){
      this.state.allBookingRequestList = this.props.requests;
      this.setState({ isInitialLoad: true});
    }
    
    if(this.state.allBookingRequestList.length == 0){
      return(<div id="noResultsDiv">No results found.</div>)
    }

    this.state.allBookingRequestList.forEach((request) => {
      hotels.push(<BookingRequestBadge request={request} key={request.id} updatePinUnpin={this.props.updatePinUnpin} handleTogglePinUnpinIcon={this.handleTogglePinUnpinIcon} handleArchive={this.handleArchive} />);
    });
  
    return hotels; 
  }

  onEndDateChange(endDate){
    let startDateValue = this.state.startDate.format('YYYY-MM-DD')
    let endDateValue = endDate.format('YYYY-MM-DD')
    this.setState(({ endDate }));
    this.actionAfterFilterData(0, this.state.searchTerm, this.state.selectedStatusOption, startDateValue, endDateValue);
  }

  handleStatusSelect(eventKey, event){
    this.setState({ selectedStatusOption: statusOptions[eventKey]});
    console.log(this.state.selectedStatusOption);      
    this.actionAfterFilterData(0, this.state.searchTerm, statusOptions[eventKey], this.state.startDate.format('YYYY-MM-DD'), this.state.endDate.format('YYYY-MM-DD'));      
  }

  handleSearchTerm(e){    
    this.setState({searchTerm:e.target.value});
    this.actionAfterFilterData(0, e.target.value, this.state.selectedStatusOption, this.state.startDate.format('YYYY-MM-DD'), this.state.endDate.format('YYYY-MM-DD'));      
  }

  actionAfterFilterData(page, searchTerm, selectedStatus, startDate, endDate){ 
    this.props.requestBookings(0, searchTerm, selectedStatus, startDate, endDate, (response) => {
      if(typeof(response.results) != 'undefined'){          
        this.setState({ allBookingRequestList:  response.results});
        this.handleShowCards();
        if(selectedStatus=="All Requests"){
          this.props.getTour((response)=>{
            this.setState({ tourStatus:response.results});
            this.chageTourState();
          });
        }
      }        
    });
  }

  changeView(){
    if(this.state.viewMode === 'list'){
      this.setState({ viewMode: 'grid'})
    }
    else{
      this.setState({ viewMode: 'list'})
    }
  }

  renderCurrentViewHtml(){
    const ButtonColumn = ({ value }) => (
      <ButtonGroup>
        <Button bsStyle="info" data-item={value} onClick={this.showDetailView}>
          <i className="fa fa-pencil fa-lg" />
        </Button>        
      </ButtonGroup>
      );
    
    let groups = []    
    this.state.allBookingRequestList.forEach((request) => {
    groups.push({
      group: (typeof(request.brand) != 'undefined' && request.brand != null) ? request.brand.name : '',
      tour: typeof(request.tour.name) != 'undefined' ? request.tour.name : '',
      tagline: typeof(request.tour.tag_line) != 'undefined' ? request.tour.tag_line : '',
      start: moment(request.tour.start).format('MMM DD, YYYY'),
      end: moment(request.tour.end).format('MMM DD, YYYY'),
      id: request.id
    }
      );
    });

    if(this.state.viewMode === 'list')
    {
      return(
            <div className="row">
            <InfiniteScroll
              pageStart={0}
              loadMore={this.loadFunc}
              hasMore={this.props.next !== null}
              loader={<div className="loader">Loading ...</div>}>
              {this.handleShowCards()}
            </InfiniteScroll>
          </div>
    );
    }
    else{
      return(
          <div>
            <Griddle
              data={groups}
              styleConfig={styleConfig}
              components={{
                SettingsToggle: () => <span />,
                Pagination: () => <span />,
              }}
            >
          <RowDefinition>
            <ColumnDefinition id="group" order={1} title="Group" />
            <ColumnDefinition id="tour" order={2} title="Tour"  />
            <ColumnDefinition id="tagline" order={3} title="Tagline" />
            <ColumnDefinition id="start" order={4} title="Start" />
            <ColumnDefinition id="end" order={5} title="End" />
            <ColumnDefinition id="id" title=" " customComponent={ButtonColumn} />
          </RowDefinition>
        </Griddle>
      </div>
      );
    }
    
  }

  renderViewButton(){
     if(this.state.viewMode === 'grid'){
      return(
       <ButtonToolbar>
          <Button bsStyle="default" onClick={this.changeView}>
            <i className="fa fa-th-large"></i>
          </Button>
           </ButtonToolbar>);
          }
        else{
           return(
       <ButtonToolbar>
          <Button bsStyle="default" onClick={this.changeView}>
            <i className="fa fa-bars"></i>
          </Button>
           </ButtonToolbar>);
        }
      }
  handleToggleCalendar = () => {
    this.setState({ isCalendarOpen: !this.state.isCalendarOpen });
  };

  onDateRangeSelect = (value, states) => {
    let startDateValue = value.start.format('YYYY-MM-DD')
    let endDateValue = value.end.format('YYYY-MM-DD')
    this.setState({
      startDate: value.start,
      endDate: value.end
    })
    this.actionAfterFilterData(0, this.state.searchTerm, this.state.selectedStatusOption, startDateValue, endDateValue);
    this.setState({
      isCalendarOpen: false
    })
  };

  render() {
    let icon = <i className="fa fa-search requestSearchFieldIcon" />;
    const dateRangeValue = moment.range(this.state.startDate, this.state.endDate);
   
    return (
      <div className="content-tours">
        <div className="container-fluid">
          <div className="row tour-head">
            <div className="col-xs-12 col-sm-8 col-md-8 col-lg-8 tour-headText">
              <h2>Booking Requests</h2>
              <hr />
            </div>
          </div>
          <div className="row filters" id="filterAndSearchSection">
          {this.state.isCalendarOpen &&
            (<div className="booking-requests-date-range-picker-section" ref={node => this.node = node}>
              <DateRangePicker
              numberOfCalendars = {2}
              value={dateRangeValue}
              onSelect={this.onDateRangeSelect}
              showLegend={true}
              selectedLabel=" Click on month/year to select month/year quickly"
            /></div>)}
            <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2" id="statusFilter">
              <span id="filterHeading">Filter </span>
              <DropdownButton title={this.state.selectedStatusOption} onSelect={(e) => this.handleStatusSelect(e)}>
                {statusOptions.map((options, i) => (
                <MenuItem key={i} eventKey={i}>
                  {options}
                </MenuItem>
                ))}
              </DropdownButton>
             </div>
             <div className="col-xs-12 col-sm-12 col-md-7 col-lg-7" id="divDateFilter">
               <div className="col-xs-12 col-sm-1 col-md-1 col-lg-1">
               </div>
               <div id="bookingRequestsDateRange" onClick={this.handleToggleCalendar} >
                  <i className="fa fa-calendar booking-request-calendar-icon" aria-hidden="true"></i>
                  {this.state.startDate.format("MM/DD/YYYY")}
                  {" - "}
                  {this.state.endDate.format("MM/DD/YYYY")}
              </div>
              </div>
             <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2">
              <SearchField
                id='txtSearch'
                defaultValue={this.state.searchTerm}
                className='form-control fontAwesomeSearchIcon'
                placeholder="Search"
                onChange={(e) => this.handleSearchTerm(e)}                
                />
              {icon}
             </div>

             <div className="col-xs-12 col-sm-1 col-md-1 col-lg-1 view">
                {this.renderViewButton()}
            </div>
          </div>
          {this.renderCurrentViewHtml()}
        </div>
      </div>
    );
  }
}
BookingRequestList.propTypes = {
};
export default BookingRequestList;



// WEBPACK FOOTER //
// src/routes/booking/components/BookingRequestList.js